import React, { Component, Fragment } from 'react';
import classes from './Signup.module.css';
import { Link } from 'react-router-dom';
import logo from '../../assets/logo.png';
import loader from '../../assets/loader.svg'
import FormFields from './FormFields/FormFields';
import axios from 'axios';
import axios2 from '../../axios';
import {connect} from 'react-redux';

class Signup extends Component {

    state = {
        signUpForm : {
            email: {
                elementType: 'input',
                config:{
                    type: 'email',
                    value: '',
                    id: 'email',
                    maxLength: 30
                },
                label: 'Email',
                value: '',
                validation: {
                    required: true,
                    email: true
                },
                isTouched: false,
                isDirty: false,
                valid: false
            },
            fullName: {
                elementType: 'input',
                config:{
                    type: 'text',
                    id: 'name',
                    maxLength: 30
                },
                label: 'Full Name',
                value: '',
                validation: {
                    required: true,
                    minLength: 3
                },
                isTouched: false,
                isDirty: false,
                valid: false
            },
            password: {
                elementType: 'input',
                config:{
                    type: 'password',
                    id: 'pwd',
                    maxLength: 20
                },
                label: 'Password',
                value: '',
                validation: {
                    required: true,
                    minLength: 6
                },
                isTouched: false,
                isDirty: false,
                valid: false
            },
            signupBtn: {
                elementType: 'button',
                config:{
                    type: 'button',
                    id: 'signup'
                },
                label: 'Sign Up',
                valid: true
            }
        
        },
        isFormValid: false,
        loading: false,
        error:''
    }

    inputOnChangeHandler = (event, key) => {
       const form = {
        ...this.state.signUpForm
       };

       const inputField = {...form[key]};
       inputField.value = event.target.value;
       inputField.isDirty = true;
       inputField.valid = this.validate(inputField.validation, event.target.value);
       form[key] = inputField;

        let isFormValid = true;
        for (let inputIdent in form) {
            if(!form[inputIdent].valid) isFormValid = false;
        }
        this.setState({
            signUpForm: form,
            isFormValid: isFormValid
        });
    
    }

    validate = (validation, value) => {
        let isValid = true;

        if(validation.required) {
            isValid =  value.trim() !== '' && isValid;
        }
         if(validation.minLength) {
            isValid = value.trim().length >= validation.minLength && isValid;
         }
         if(validation.email) {
             isValid = value.search('^[a-z0-9._%+-]+@[a-z0-9.-]+[.][a-z]{2,4}$') !== -1 && isValid;
         }
         return isValid;
    }

    onBlurHandler = (event, key) => {
        let value = event.target.value;
        value = value.trim().replace(/ {2}/g, ' ');
        if(key === 'fullName') value = this.titleCase(value);
        event.target.value = value;
        this.inputOnChangeHandler(event, key);
    }

    titleCase = (value) => {
        const words = value.toLowerCase().split(' ');
        let titleCasedValue = [];
        for(let word of words) {
            titleCasedValue.push(word.charAt(0).toUpperCase() + word.slice(1));
        }

        return titleCasedValue.join(' ');
    }

    onSignUp = () => {
        if(!this.state.isFormValid) return;
        this.setState({loading: true,error:''});
        const user = {
            email: this.state.signUpForm.email.value,
            password: this.state.signUpForm.password.value,
            returnSecureToken: true
        }

        const userData = {
            name: this.state.signUpForm.fullName.value,
            followers: [''],
            following: [''],
            account_status: 'AVLBL',
            isAccountPrivate: false,
            isVerified: false,
            requests: [''],
            sentRequest: [''],
            posts: [''],
            notifications: [{
                key: 'GREET',
                name: 'FakeInsta Officials',
                isRead: false,
                userId: 'eH1t7g0JGugNWntmDcgHkWPxyod2',
                profilePic: 'https://firebasestorage.googleapis.com/v0/b/fakeinsta-1.appspot.com/o/images%2FeH1t7g0JGugNWntmDcgHkWPxyod2%2Ffakeinsta.jpg?alt=media&token=a83bf060-3f42-4633-81e1-c06f6fa53a5d',
                timeStamp: new Date()
            }],
            bio: 'NA',
            profilePic: 'https://firebasestorage.googleapis.com/v0/b/fakeinsta-1.appspot.com/o/images%2Fno_user%2Fno_user.jpg?alt=media&token=eae91311-b422-4c89-8d58-b4ba21c8f99a'
        }

        const messages = {
            dummyUser :[{message:'NA',status: true, sender:'userId', timestamp: 'date'}]
        }
        axios2.post(':signUp?key=AIzaSyCz-SR_b_8Rn41e9xr1i7iQcwJaCR9DFJ0', user)
        .then(response => {
          axios.put('/messages/'+ response.data.localId + '.json?auth=' + 
          response.data.idToken, messages).catch(err=>console.log(err));
          
         axios.put('/users/'+ response.data.localId + '.json?auth=' + 
         response.data.idToken, userData)
         .then(() => {
            this.props.setLoginStatus(true, response.data.localId, response.data.idToken, new Date().getTime() + (response.data.expiresIn * 1000));
            localStorage.setItem('tokenData', JSON.stringify({
                localId: 'fkiG' + response.data.localId,
                idToken: response.data.idToken,
                expire: new Date().getTime() + (response.data.expiresIn * 1000)
            }));
           this.props.setUserData(userData);
           this.props.history.replace({pathname: '/'})
         })

         axios.get('/newUsers.json?auth=' + response.data.idToken)
         .then(res=>{
             res.data.unshift({userId: response.data.localId, time: new Date()});
             axios.put('/newUsers.json?auth=' + response.data.idToken, res.data)
         })
           
        })
        .catch(err => {
            if(err.response.data.error.message === 'EMAIL_EXISTS') {
                this.setState({loading:false, error:'Email id already exists'});
            }
        })
        
    }

   
    render() {
       
        return(
        <Fragment>
        <div className={classes.background}></div>

        <div className={classes.signupModel}>
            
            <div className={classes.signup}>
            <div>
               <img src={logo} width="200" height="60" alt="logo"/>
            </div>
            <div style={{marginTop: '25px'}}>
              <form>
                    {Object.keys(this.state.signUpForm).map(key => (
                        <FormFields key={key} 
                            elementType={this.state.signUpForm[key].elementType}
                            config={this.state.signUpForm[key].config}
                            label={this.state.signUpForm[key].label}
                            value={this.state.signUpForm[key].value}
                            isValid={this.state.signUpForm[key].valid}
                            isDirty={this.state.signUpForm[key].isDirty}
                            change={(event)=>this.inputOnChangeHandler(event, key)}
                            blur={(event)=>this.onBlurHandler(event, key)}
                            click={this.onSignUp}
                            isFormValid = {this.state.isFormValid}
                        />
                    ))}
               
              </form>
              {this.state.error !== ''?
                <div className={classes.error}>{this.state.error}</div>:null
              }
              </div>
            </div>
            <div className={classes.signin}>
              <p>
                Have an account? &nbsp;
                <Link to="/" style={{color: '#efff00',fontWeight: 500,textDecoration: 'none'}}>
                    Log In
                </Link>
              </p>
            </div>
            {this.state.loading?
            <div className={classes.loader}>
                <img src={loader} alt="loader" />
            </div>
            :null
            }
        </div>
        </Fragment>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setLoginStatus: (isLoggedIn, userId, authToken, expiresIn) => 
                        dispatch({
                            type: 'SET_LOGIN_STATUS',
                            isLoggedIn: isLoggedIn,
                            localId: userId,
                            idToken: authToken,
                            expiresIn: expiresIn
                        }),
        setUserData: (value) => dispatch({type: 'SET_USER_DATA', value:value})
    }
}
export default connect(null, mapDispatchToProps)(Signup);